import React, { useEffect, useState, useRef } from 'react';
import { styled, useTheme } from '@mui/material/styles';

import './style.css'
import logo from '../../../assets/images/logo.jpeg';
import { Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button, Typography, Chip, Drawer } from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group, HomeOutlined, GroupsOutlined, CallOutlined, KeyboardArrowDown, KeyboardArrowUp, KeyboardArrowRight } from '@mui/icons-material';
import Icon from '@mui/material/Icon';
import { useSelector } from 'react-redux';
import { element } from 'prop-types';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useHistory, useLocation, useParams } from "react-router-dom";
import { CONFIG } from '../../../config';
import Avatar from '../../components/avatar';

const drawerWidth = 280;

export const SubElement = ({ name, active, activeChild, setActiveChild, onChange, parent, data, multiple, setChildOpen, childOpen, openObj, setOpen }) => {

  const childs2 = Object.values((data.item || {}))
  const open = name in childOpen;
  // console.log('------------->', childOpen,  name, activeChild)
  // console.log(data, parent, 'check nested childs');
  const { path, hide } = data;
  const history = useHistory();
  return (
    <>
      <Box sx={{ borderLeft: active && !data.child ? '0.3em solid #F28627' : '', background: active && !data.child ? '#F1F1F2' : '', pb: '.2em', bt: '.2em', cursor: 'pointer' }}
        onClick={() => {
          onChange(parent)
          !data.child && setTimeout(() => { setActiveChild(name) }, 50)
          !data.child && history.push(path || '/')
          setChildOpen({ ...childOpen, [name]: true })
        }}
      >
        <Box sx={{ ml: 4 }}>
          <Typography variant='p' sx={{ fontWeight: 500, color: active ? '#F28627' : 'grey' }} >{data.label || name}</Typography>
          {multiple && open && <KeyboardArrowDown sx={{ color: active ? '#F28627' : '#0669BF', cursor: 'pointer' }} onClick={(e) => {
            e.stopPropagation()
            delete childOpen[name]
            setChildOpen({ ...childOpen })
          }} />}
          {multiple && !open && <KeyboardArrowRight sx={{ color: active ? '#F28627' : '#0669BF', cursor: 'pointer' }} onClick={(e) => {
            e.stopPropagation()
            setChildOpen({ ...childOpen, [name]: true })
          }} />}
        </Box>
      </Box>
      {/* {
        open && multiple &&
        <Box sx={{ mb: 2 }}>
          {childs2.map((c, i) => {
            return (
              <Box
              key={i}
                sx={{ background: active&&!data.child ? '#F1F1F2' : '', pb: '.2em', bt: '.2em', cursor: 'pointer', textAlign: 'start', pl: '3em' }}
                onClick={(e) => {
                  onChange(parent)
                  setTimeout(() => { setActiveChild(name) }, 50)
                  history.push(path, c.routeData || '/')
                  // console.log(c,name, 'if pressed');
                }}
              >
                <Typography variant='p' sx={{ fontWeight: 500, color: 'grey' }} >{c.name}</Typography>
              </Box>
            )
          })}
        </Box>
      } */}



      {
        open && multiple && childs2 && Array.isArray(childs2) && childs2.length > 0 &&
        <Box sx={{ mt: 0, mb: 2, ml: 2 }}>
          {
            childs2.filter(c => !c.hide).map((c, i) => {
              // {console.log('ppp>pp--------?', activeChild,c.name, active)}
              return (<SubElement key={i} data={c} parent={name} name={c.name}
                openObj={openObj}
                setOpen={setOpen}
                activeChild={activeChild}
                active={activeChild == c.name} setActiveChild={setActiveChild}
                onChange={onChange} multiple={c.child ? true : false} setChildOpen={setChildOpen} childOpen={childOpen} />)
            })
          }
        </Box>

      }
    </>
  )
}


export const Element = ({ children, active, name, multiple, openObj, activeChild, items, onChange, setActiveChild, setOpen, data, setChildOpen, childOpen }) => {
  const childs = Object.values((items || {}))
  const open = name in openObj;

  const onChange2 = (data) => {
    // console.log('change --------------2',data)
    onChange(data)
  }

  return (
    <>
      <Box sx={{ display: 'flex', pt: 1, justifyContent: 'space-between', cursor: 'pointer' }}
        onClick={() => {
          if (!multiple)
            onChange(name)
          setOpen({ ...openObj, [name]: true }, setChildOpen({}))
        }}>
        <Box>
          {
            React.Children.map(children, child => {
              if (React.isValidElement(child)) {
                return React.cloneElement(child, { sx: { color: active ? '#F28627' : '#0669BF' } });
              }
              return child;
            })
          }
          &nbsp;&nbsp;
          <Typography variant='p' sx={{ fontWeight: 500, color: active ? '#F28627' : '#0669BF' }}>{data.label || name}</Typography>
        </Box>
        <Box>
          {multiple && open && <KeyboardArrowDown sx={{ color: active ? '#F28627' : '#0669BF', cursor: 'pointer' }} onClick={(e) => {
            e.stopPropagation()
            delete openObj[name]
            setOpen({ ...openObj })
          }} />}
          {multiple && !open && <KeyboardArrowRight sx={{ color: active ? '#F28627' : '#0669BF', cursor: 'pointer' }} onClick={(e) => {
            e.stopPropagation()
            setOpen({ ...openObj, [name]: true })
          }} />}
        </Box>

      </Box>
      {
        open && multiple && childs && Array.isArray(childs) && childs.length > 0 &&
        <Box sx={{ mt: 2, mb: 2 }}>
          {
            childs.filter(c => !c.hide).map((c, i) => {
              // {console.log(c, 'check for c')}
              return (<SubElement key={i} data={c} parent={name} name={c.name}
                openObj={openObj}
                setOpen={setOpen}
                activeChild={activeChild}
                active={active && activeChild == c.name} setActiveChild={setActiveChild}
                onChange={onChange2} multiple={c.child ? true : false} setChildOpen={setChildOpen} childOpen={childOpen} />)
            })
          }
        </Box>

      }
    </>
  )
}

const navElememts = {
  'Dashboard': {
    name: 'Dashboard',
    // hide: true,
    logo: () => <HomeOutlined />,
    path: '/'
  },

  'Human Resource': {
    name: 'Human Resource',
    path: '/hr',
    logo: () => <GroupsOutlined />,
    child: true,
    items: {

      'Employee Management': {
        name: 'Employee Management',
        path: '/hr/employee-management'
      },
      'Attendance': {
        name: 'Attendance',
        path: '/hr/attendance'
      },
      'Leave Requests': {
        name: 'Leave Requests',
        path: '/hr/leaves'
      },

      'Entities': {
        name: 'Entities',
        path: '/hr/entities'
      },
    }
  },
  'ECD': {
    name: 'ECD',
    logo: () => <CallOutlined />,
    path: '/telecaller',
    child: true,
    items: {
      'Caller Dashboard': {
        name: 'Caller Dashboard',
        path: '/telecaller/caller-dashboard'
      },

      'Reports': {
        hide: true,
        name: 'Reports',
        path: '/telecaller/caller-dashboard/report'
      }



    }
  },

  'Team Lead': {
    name: 'Team Lead',
    label: 'ECD',
    path: '/lead',
    logo: () => <EngineeringOutlinedIcon />,
    child: true,
    items: {
      'Resource Management': {
        name: 'Resource Management',
        path: '/lead/resource-management'
      },
      'Call Data': {
        name: 'Call Data',
        label: 'Call Data',
        path: '/lead/call-data',
        child: true,
        item: {
          'Master Database': {
            name: 'Master Database',
            path: '/lead/call-data/master-database',
          },
          'Allocations': {
            name: 'Allocations',
            path: '/lead/call-data/allocations'
          },
          'Reports': {
            name: 'Reports',
            path: '/lead/call-data/reports'
          },
          'Upload': {
            name: 'Upload',
            path: '/lead/call-data/upload'
          },
          'Analytics': {
            name: 'Analytics',
            path: '/lead/call-data/analytics'
          },
          'Calls': {
            name: 'Calls',
            path: '/lead/call-data/calls'
          }
        }
      },
      'View Shifts': {
        name: 'View Shifts',
        path: '/lead/view-shifts'
      },
      // 'Quality Assurance': {
      //   name: 'Quality Assurance',
      //   path: '/lead/quality-assurance',
      //   child: true,
      //   item: {
      //     'Call Recordings':{
      //       name: 'Call Recordings',
      //       path: '/lead/quality-assurance',
      //     },
      //     'Telecallers': {
      //       name: 'Telecallers',
      //       path: '/lead/telecallers',
      //     },
      //     'Insights': {
      //       name: 'Insights',
      //       path: '/lead/insights'
      //     },
      //   }   
      // }
      // 'Sankalp': {
      //     name: 'Sankalp',
      //     path: '/sankalp'
      // },

      // 'Campaigns': {
      //     name: 'Campaigns',
      //     path: '/campaigns'
      // }
    }
  },
  'Quality Assurance': {
    name: 'Quality Assurance',
    path: '/lead/quality-assurance',
    logo: () => <VerifiedIcon />,
    child: true,
    items: {
      'Call Recordings': {
        name: 'Call Recordings',
        path: '/lead/quality-assurance',
      },
      'Telecallers': {
        name: 'Telecallers',
        path: '/lead/telecallers',
      },
      'Insights': {
        name: 'Insights',
        path: '/lead/insights'
      },
    }
  },
  'Approve Leaves': {
    name: 'Approve Leaves',
    logo: () => <EventAvailableOutlinedIcon />,
    path: '/leave-actions'
  },
  'Apply Leave': {
    name: 'Apply Leave',
    logo: () => <CalendarMonthOutlinedIcon />,
    hide: true,
    path: '/apply-leave'
  },

  'Admin': {
    name: 'Admin',
    path: '/admin',
    logo: () => <GroupsOutlined />,
    child: true,
    items: {

      'Assets': {
        name: 'Assets',
        path: '/admin/assets'
      },
    }
  }

}

const pathMap = {
  '/leave-actions': {
    name: 'Approve Leaves',
    child: false
  },
  '/telecaller/caller-dashboard/report': {
    name: 'ECD',
    child: 'Reports'
  },
  '/lead/call-data': {
    name: 'Team Lead',
    child: 'Call Data'
  },
  '/lead/view-shifts': {
    name: 'Team Lead',
    child: 'View Shifts'
  },
  '/lead/sankalp': {
    name: 'Team Lead',
    child: 'Sankalp'
  },
  '/lead/campaigns': {
    name: 'Team Lead',
    child: 'Campaigns'
  },
  '/telecaller/caller-dashboard': {
    name: 'ECD',
    child: 'Caller Dashboard'
  },

  '/lead/resource-management': {
    name: 'Team Lead',
    child: 'Resource Management'
  },

  '/admin/assets': {
    name: 'Admin',
    child: 'Assets'
  },

  '/': {
    name: 'Dashboard',
    child: false
  },
  '/hr/entities': {
    name: 'Human Resource',
    child: 'Entities'
  },
  '/hr/employee-management': {
    name: 'Human Resource',
    child: 'Employee Management',
  },
  '/hr/attendance': {
    name: 'Human Resource',
    child: 'Attendance',
  },
  '/hr/leaves': {
    name: 'Human Resource',
    child: 'Leave Requests',
  },
  '/leave-actions': {
    name: 'Leave Actions',
    child: false
  },
  '/apply-leave': {
    name: 'Apply Leave',
    child: false
  },
  '/hr/employee-management/detail': {
    name: 'Human Resource',
    child: 'Employee Management',
  },
  '/lead/quality-assurance': {
    name: 'Quality Assurance',
    child: 'Quality Assurance'
  },
  '/lead/call-data/master-database': {
    name: 'Team Lead',
    child: 'Master Database',
    parent: 'Call Data'
  },
  '/lead/call-data/reports': {
    name: 'Team Lead',
    child: 'Reports',
    parent: 'Call Data'
  },
  '/lead/call-data/allocations': {
    name: 'Team Lead',
    child: 'Allocations',
    parent: 'Call Data'
  },
  '/lead/call-data/upload': {
    name: 'Team Lead',
    child: 'Upload',
    parent: 'Call Data'
  },
  '/lead/call-data/analytics': {
    name: 'Team Lead',
    child: 'Analytics',
    parent: 'Call Data'
  },
  '/lead/call-data/calls': {
    name: 'Team Lead',
    child: 'Calls',
    parent: 'Call Data'
  },
  // '/tellecaller/apply-leave': {
  //     name: 'Tele Calling',
  //     child: 'Apply Leave'
  // }
}



export const Sidebar = ({ openS }) => {
  const history = useHistory();
  const location = useLocation()
  const params = useParams()
  const { roles, user, authencation_error, role } = useSelector((state) => (state.user || {}))
  const getNavigations = () => {
    const roleObj = (roles || []).find(r => r._id == role)
    if (!roleObj) {
      return [];
    }
    return Object.values(navElememts).filter((e) => {
      return roleObj.priviledges.some(p => p.name == e.name)
    })
  }

  const [list, setList] = useState(getNavigations())



  // const list = Object.values(navElememts)

  const [active, setActive] = useState(pathMap?.[location.pathname]?.name)
  const [activeChild, setActiveChild] = useState(pathMap?.[location.pathname]?.child)
  const previousActive = useRef(null)
  const [open, setOpen] = useState({ [pathMap?.[location.pathname]?.name]: true })
  const [childOpen, setChildOpen] = useState({})
  const [roleWiseDefaultMap, setRoleWiseDefaultMap] = useState({});



  useEffect(() => {
    setList(getNavigations())
    setRoleWiseDefaultMap(roles.reduce((a, e) => {
      a[e._id] = {
        _id: e._id,
        name: e.name
      }
      return a
    }, {}))
  }, roles)

  const checkForDefaultRoute = () => {
    try {

      // console.log('mount', location.pathname, obj)
      // if (location.pathname == '/' && obj) {
      //   history.push(obj.default)
      //   setActive(pathMap[obj.default].name)
      //   setTimeout(() => { setActiveChild(pathMap[obj.default].child) }, 50)

      //   setOpen({ [pathMap[obj.default].name]: true })
      // } else {
      setActive(pathMap[location.pathname].name)
      setActiveChild(pathMap[location.pathname].child)
      if (pathMap[location.pathname].parent) {
        setChildOpen({ ...childOpen, [pathMap[location.pathname].parent]: true })
      }
      setOpen({ [pathMap[location.pathname].name]: true })
      // }
    } catch (e) {

    }
  }

  useEffect(() => {
    // console.log('on role', location.pathname)
    checkForDefaultRoute()
  }, [role])

  useEffect(() => {
    // console.log('on mount', location.pathname)
    checkForDefaultRoute()
  }, [])

  useEffect(() => {
    // console.log('on location changes', location.pathname)
    checkForDefaultRoute()



  }, [location])

  useEffect(() => {

    if (previousActive.current)
      setActiveChild(null)
    previousActive.current = active
  }, [active])

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          zIndex: 120
        },
      }}
      variant="persistent"
      anchor="left"
      open={openS}
    >
      <Box sx={{ width: drawerWidth, mt: '4em', position: 'fixed', boxShadow: 3, height: '100vh', pt: 3, pl: 3, pr: 3, background: 'white', zIndex: 20 }}>
        <Box sx={{ borderBottom: '1px solid grey', pb: 2, display: 'flex', justifyItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', paddingRight: '10px' }}>
            {
              user &&
              <>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ color: '#183b56' }}>{user.name}
                  </Typography>
                  <Chip size="small" label={`${roleWiseDefaultMap[role] ? roleWiseDefaultMap[role].name : ''}`} variant="outlined" />

                </Box>

                <Typography sx={{ color: '#375674', fontSize: '13px' }}>Emp. code: {user.uuid}</Typography>
              </>
            }

          </Box>
          <Box>
            <Avatar seed={user?.uuid || 'default-badge-avatar'} />
            {/* <AccountCircleOutlined sx={{ fontSize: '3em', color: 'grey' }} /> */}
          </Box>
        </Box>
        <Box>
          {
            list && Array.isArray(list) &&
            list.filter(e => !e.hide).map((element, i) => {
              return (
                <Element key={i} name={element.name} active={active == element.name} multiple={!!element.child}
                  openObj={open}
                  activeChild={activeChild}
                  items={element.items}
                  data={element}
                  onChange={(data) => {
                    setActive(data)
                    if (navElememts[data] && !navElememts[data].child) {
                      history.push(navElememts[data].path)
                    }
                  }}
                  setOpen={setOpen}
                  setActiveChild={setActiveChild}
                  childOpen={childOpen}
                  setChildOpen={setChildOpen}
                >
                  {element.logo()}
                </Element>
              )
            })
          }


        </Box>
      </Box>
    </Drawer>
  )
}